import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/** Register the five semantic typography roles as font-size utilities. This
 * keeps each role alongside text colors while still deduping competing roles. */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          type: ["subtext", "body", "title", "heading", "page-title"],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
